<app-navbar-style-admin></app-navbar-style-admin>
<!-- your-component.component.html -->
<div class="blog-details-area pt-50 pb-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="blog-article">
                    <!-- <div class="d-flex justify-content-center signBody align-middle "> -->
                    <div class="card loginCard">
                        <header class="card-header" style="background: var(--mainColor);border-radius:100px;">
                            <h4 class="card-title mt-2 text-center" style="color:white">Update Type</h4>
                        </header>
                        <article class="card-body">
                            <div class="container">
                                <!-- <h2>Create Type</h2> -->
                                <form [formGroup]="typeForm" (ngSubmit)="onSubmit()">
                                    <!-- General properties -->
                                    <div class="form-group">
                                        <label>Select category:</label>
                                        <ng-select [multiple]="true" formControlName="CategoryId" #myselect
                                            (change)="onMaterialGroupChange($event)" [(ngModel)]="category">
                                            <ng-option *ngFor="let obj of categories" [value]="obj.categoryId"
                                                class="form-control">{{obj.categoryName}}</ng-option>
                                        </ng-select>
                                        <div *ngIf="typeForm.get('CategoryId')?.hasError('required') && typeForm.get('CategoryId')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Select Sub category:</label>
                                        <ng-select [multiple]="true" formControlName="SubcategoryId" #myselect
                                            (change)="onMaterialGroupChange($event)" [(ngModel)]="subcategoty">
                                            <ng-option *ngFor="let obj of subcategories" [value]="obj.subcategoryId"
                                                class="form-control">{{obj.subcategoryName}}</ng-option>
                                        </ng-select>
                                        <div *ngIf="typeForm.get('SubcategoryId')?.hasError('required') && typeForm.get('SubcategoryId')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="TypeTitle">Type Title:</label>
                                        <input type="text" class="form-control" formControlName="TypeTitle">
                                        <div *ngIf="typeForm.get('TypeTitle')?.hasError('required') && typeForm.get('TypeTitle')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="TypeDescription">Type Description:</label>
                                        <input type="text" class="form-control" formControlName="TypeDescription">
                                        <div *ngIf="typeForm.get('TypeDescription')?.hasError('required') && typeForm.get('TypeDescription')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>

                                    <!-- Location properties -->
                                    <div class="form-group">
                                        <label for="Location">Location:</label>
                                        <input type="text" class="form-control" formControlName="Location">
                                        <div *ngIf="typeForm.get('Location')?.hasError('required') && typeForm.get('Location')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="Phone">Phone:</label>
                                        <input type="text" class="form-control" formControlName="Phone">
                                        <div *ngIf="typeForm.get('Phone')?.hasError('required') && typeForm.get('Phone')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="Email">Email:</label>
                                        <input type="email" class="form-control" formControlName="Email">
                                        <div
                                            *ngIf="typeForm.get('Email').hasError('email') && typeForm.get('Email').touched">
                                            Invalid email address
                                        </div>
                                        <div
                                            *ngIf="typeForm.get('Email').hasError('required') && typeForm.get('Email').touched">
                                            Email is required
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="Address">Address:</label>
                                        <input type="text" class="form-control" formControlName="Address">
                                    </div>
                                    <div class="form-group">
                                        <label for="Street">Street:</label>
                                        <input type="text" class="form-control" formControlName="Street">
                                    </div>
                                    <div class="form-group">
                                        <label for="City">City:</label>
                                        <input type="text" class="form-control" formControlName="City">
                                    </div>
                                    <div class="form-group">
                                        <label for="State">State:</label>
                                        <input type="text" class="form-control" formControlName="State">
                                    </div>
                                    <div class="form-group">
                                        <label for="Country">Country:</label>
                                        <input type="text" class="form-control" formControlName="Country">
                                    </div>

                                    <!-- Additional information properties -->
                                    <div class="form-group">
                                        <label for="Tags">Tags:</label>
                                        <input type="text" class="form-control" formControlName="Tags">
                                    </div>
                                    <div class="form-group">
                                        <label for="MetaKeys">Meta Keys:</label>
                                        <input type="text" class="form-control" formControlName="MetaKeys">
                                    </div>

                                    <!-- Date-related properties -->
                                    <div class="form-group">
                                        <label for="StartedYear">Started Year:</label>
                                        <input type="string" class="form-control" formControlName="StartedYear">
                                    </div>
                                    <div class="form-group">
                                        <label for="isVerified">Is Verified:</label>
                                        <input type="checkbox" class="form-check-input" formControlName="isVerified">
                                    </div>

                                    <!-- Audit properties -->
                                    <!-- <div class="form-group">
                                        <label for="Createdby">Created By:</label>
                                        <input type="text" class="form-control" formControlName="Createdby">
                                    </div>
                                    <div class="form-group">
                                        <label for="CreatedDate">Created Date:</label>
                                        <input type="text" class="form-control" formControlName="CreatedDate">
                                    </div>
                                    <div class="form-group">
                                        <label for="Updatedby">Updated By:</label>
                                        <input type="text" class="form-control" formControlName="Updatedby">
                                    </div>
                                    <div class="form-group">
                                        <label for="UpdatedDate">Updated Date:</label>
                                        <input type="text" class="form-control" formControlName="UpdatedDate">
                                    </div> -->

                                    <!-- Description properties -->
                                    <div class="form-group">
                                        <label for="Description">Description:</label>
                                        <quill-editor [styles]="{height: '200px'}" (onFocus)="focus($event)"
                                            formControlName="Description" (onEditorChanged)="changedEditor($event)"
                                            (onBlur)="blur($event)" (onEditorCreated)="created($event)"></quill-editor>
                                        <div *ngIf="typeForm.get('Description')?.hasError('required') && typeForm.get('Description')?.touched"
                                            class="error-block">
                                            This field is required.
                                        </div>
                                    </div>


                                    <!-- <div class="form-group">
                                        <label for="Extra1">Extra 1:</label>
                                        <input type="text" class="form-control" formControlName="Extra1">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra2">Extra 2:</label>
                                        <input type="text" class="form-control" formControlName="Extra2">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra3">Extra 3:</label>
                                        <input type="text" class="form-control" formControlName="Extra3">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra4">Extra 4:</label>
                                        <input type="text" class="form-control" formControlName="Extra4">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra5">Extra 5:</label>
                                        <input type="text" class="form-control" formControlName="Extra5">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra6">Extra 6:</label>
                                        <input type="text" class="form-control" formControlName="Extra6">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra7">Extra 7:</label>
                                        <input type="text" class="form-control" formControlName="Extra7">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra8">Extra 8:</label>
                                        <input type="text" class="form-control" formControlName="Extra8">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra9">Extra 9:</label>
                                        <input type="text" class="form-control" formControlName="Extra9">
                                    </div>
                                    <div class="form-group">
                                        <label for="Extra10">Extra 10:</label>
                                        <input type="text" class="form-control" formControlName="Extra10">
                                    </div> -->

                                    <!-- Status and Activation properties -->
                                    <div class="form-group">
                                        <label for="isActive">Is Active:</label>
                                        <input type="checkbox" class="form-check-input" formControlName="isActive">
                                    </div>
                                    <div class="form-group">
                                        <label for="Status">Status:</label>
                                        <input type="text" class="form-control" formControlName="Status">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Rating:</label>
                                        <input type="text" class="form-control" formControlName="Rating">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Open/Close:</label>
                                        <input type="text" class="form-control" formControlName="OpenClose">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Website:</label>
                                        <input type="text" class="form-control" formControlName="Website">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Map:</label>
                                        <input type="text" class="form-control" formControlName="Map">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Listing Features:</label>
                                        <input type="text" class="form-control" formControlName="ListingFeatures">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Price:</label>
                                        <input type="text" class="form-control" formControlName="Price">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">MapLink:</label>
                                        <input type="text" class="form-control" formControlName="MapLink">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">HeadFeatures:</label>
                                        <input type="text" class="form-control" formControlName="HeadFeatures">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">isHome:</label>
                                        <input type="text" class="form-control" formControlName="isHome">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">Currency:</label>
                                        <input type="text" class="form-control" formControlName="Currency">
                                    </div>


                                    <div class="form-group">
                                        <label for="Status">Salary:</label>
                                        <input type="text" class="form-control" formControlName="Salary">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">CompanySize:</label>
                                        <input type="text" class="form-control" formControlName="CompanySize">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">TypeofMode:</label>
                                        <input type="text" class="form-control" formControlName="TypeofMode">
                                    </div>

                                    <div class="form-group">
                                        <label for="Status">TypeofWork:</label>
                                        <input type="text" class="form-control" formControlName="TypeofWork">
                                    </div>
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-success btn-block"
                                            [disabled]="!typeForm.valid">Update</button>
                                    </div>
                                    <div class="form-group text-center">
                                        <button routerLink="/typelist" class="btn btn-primary btn-block">
                                            Back</button>
                                    </div>
<!-- 
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-primary">Save</button>
                                    </div> -->
                                </form>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<app-footer-style-two></app-footer-style-two>
